import _ from 'underscore';

import { BasisTextureLoader } from 'three/examples/jsm/loaders/BasisTextureLoader';
import { KTXLoader } from 'three/examples/jsm/loaders/KTXLoader';
import TickerService from '@resn/gozer-services/ticker-service';

import env from 'core/env';
import loadTexture from './load-texture';

import { isSafari, isIOS } from '@resn/gozer-env';

import Renderer from 'component/gl/renderer';

const basisLoader = new BasisTextureLoader();
basisLoader.setTranscoderPath(`${env.CDN}static/three/basis/`);

const ktxLoader = new KTXLoader();

const CompressTextureCache = new Map();

let CompressedFormat;
const pickFormat = () => {
    if (CompressedFormat) return CompressedFormat;

    const renderer = Renderer.getRenderer();
    let format = _.pairs({
        ktx: renderer.extensions.get('WEBGL_compressed_texture_pvrtc'),
        // astc: renderer.extensions.get('WEBGL_compressed_texture_astc'),
        // etc1: renderer.extensions.get('WEBGL_compressed_texture_etc1'),
        // s3tc: renderer.extensions.get('WEBGL_compressed_texture_s3tc')
    }).find((f) => f[1]);

    const hasCompressedFormat = !!format;
    CompressedFormat = hasCompressedFormat ? format[0] : 'basis';

    return CompressedFormat;
};

const pushingQueue = [];

const queue = (d, done) => {
    pushingQueue.push({ d, done });
};

const checkQueue = () => {
    if (pushingQueue.length) {
        const { d, done } = pushingQueue.pop();
        const renderer = Renderer.getRenderer();

        renderer.initTexture(d);
        done();
    }
};

TickerService.add(checkQueue);

export default function loadCompressed(url) {
    if (typeof WebAssembly === 'undefined' || (isSafari && !isIOS)) {
        console.warn('No wasm, attempting to load .png for', url);
        return loadTexture(
            url
                .replace(/\/basis\//gi, '/')
                .replace('@small', '')
                .replace(/\.basis($|(?=#\w+$))/gi, '.png'),
        );
    }

    const format = 'basis'; //pickFormat();

    basisLoader.detectSupport(Renderer.getRenderer());

    url = url.replace(/#txt/, '');
    url = url.replace(/#ct/, '');
    url = url.replace(/\.jpg$/, '.' + format);
    url = url.replace(/\.png$/, '.' + format);

    return new Promise((resolve, reject) => {
        const data = CompressTextureCache.get(url);

        if (data) {
            // console.log('CompressTextureCache - read from cache:', url);
            resolve(data);
        } else {
            const loader = format === 'basis' ? basisLoader : ktxLoader;
            loader.load(
                url,
                (d) => {
                    // texture.needsUpdate = true;
                    queue(d, () => {
                        resolve(d);
                    });
                    CompressTextureCache.set(url, d);
                },
                () => {},
                (e) => {
                    reject(e);
                    throw new Error('Whoops! → ' + url + ' → ' + e); // rejects the promise
                },
            );
        }
    });
}
